export default function onLogin(auth) {
    const profile = auth.getProfile()

    if (profile && profile.roles && profile.roles.indexOf('ROLE_ADMIN') < 0) {
        throw new Error('Insufficient role')
    }
}
